import type { ToolCallMessagePartComponent } from '@assistant-ui/react'
import {
  COMMON_TOOL_NAMES,
  ToolRenderer,
} from '@web/components/tools/ToolRenderer'
import '@web/components/tools/tool-rendering.css'

/** All registered and unknown tools pass through the shared release-aware resolver. */
export const TOOL_UIS: Record<string, ToolCallMessagePartComponent> =
  Object.fromEntries(COMMON_TOOL_NAMES.map((name) => [name, ToolRenderer]))

export const FallbackTool = ToolRenderer
